import { Button } from '@lms/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@lms/ui/card';
import { LoaderCircle, TrashIcon } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslations } from 'use-intl';
import {
  PageBox,
  PageButtons,
  PageHeader,
  PageTitle,
} from '@/components/admin/page-box';
import { useSiteAccess } from '@/features/auth/use-auth';
import { useBrand } from '@/features/branding/brand-provider';
import AddQuestionForm from '@/features/survey/components/add-question';

// Ports app/[brand]/admin/surveys/addquestion/page.tsx. The Next server action
// redirected to the surveys list on success; here the form calls the async API
// and this route navigates there via `useNavigate`. Super-admin only. Renders
// CONTENT only; the admin `<Shell>` wraps this route.
export function QuestionsAdd() {
  const t = useTranslations('admin');
  const { slug } = useBrand();
  const { access, loading: roleLoading } = useSiteAccess(slug);
  const isSuperAdmin = access?.superAdmin ?? false;
  const navigate = useNavigate();

  if (roleLoading) {
    return (
      <div className="flex h-64 items-center justify-center">
        <LoaderCircle className="text-primary size-8 animate-spin" />
      </div>
    );
  }

  if (!isSuperAdmin) {
    return (
      <PageBox>
        <PageHeader>
          <PageTitle>{t('surveys')}</PageTitle>
        </PageHeader>
        <p className="text-muted-foreground">{t('unauthorized')}</p>
      </PageBox>
    );
  }

  return (
    <PageBox>
      <PageHeader>
        <PageTitle>{t('surveys')}</PageTitle>
        <PageButtons>
          <Button variant="destructive" asChild>
            <Link to={`/${slug}/admin/surveys`}>
              <TrashIcon className="size-4" />
              {t('discard')}
            </Link>
          </Button>
        </PageButtons>
      </PageHeader>
      <Card>
        <CardHeader>
          <CardTitle>
            {t('add', { what: t('question').toLowerCase() })}
          </CardTitle>
        </CardHeader>
        <CardContent>
          <AddQuestionForm
            onSuccess={() => navigate(`/${slug}/admin/surveys`)}
          />
        </CardContent>
      </Card>
    </PageBox>
  );
}
